const Roles = Object.freeze({
    ENTERPRISE_ADMIN: 'enterprise_admin',
    SAFETY_ADMIN: 'SA',
    SAFETY_MANAGER: 'SMA',
    SAFETY_MONITOR: 'SMO',
    COUNTRY_LEAD: 'CL',
    SAFETY_SUPPORT:'SS',
    GAP_PACKET_ADMIN: 'GA',
    IB_ADMIN: 'IBA', //SAF-17154 IB_Admin role added
    IB_COUNTRY_LEAD: 'IB_CL',
    IB_MONITOR: 'IB_MO',//SAF-19117 - IB Monitor role for read-only access
    // SAF-20237: Module-specific recipient roles for proper access control (Role Assignment - Switch Roles and its Precedence - PSR-4763)
    SAFETY_RECP: 'SAFETY_RECP', //Safety Recipient role
    GP_RECP: 'GP_RECP', //Gap Packet Recipient role
    IB_RECP: 'IB_RECP', //IB Recipient role
    IB_SUPPORT: 'IBS', // SAF-20491: IB Support role (split from Safety Support)
    GAP_PACKET_SUPPORT: 'GPS', // SAF-20491: Gap Packet Support role (split from Safety Support)
    isCountryLead: roleVal => roleVal === 'CL',
    isIBCountryLead: roleVal => roleVal === 'IB_CL'
});

export default Roles;
